export default "__VITE_ASSET__BQ$aun2U__"